/**
 * SISTEMA DE GERENCIAMENTO DE AMBIENTE - ORTODOXO SYSTEM
 * Responsável por carregar e gerenciar variáveis de ambiente de forma inteligente
 */

// URLs padrão por ambiente
const PROD_API_URL = '/api';
const DEV_API_URL = 'http://localhost:3000';

/**
 * Detecta se estamos em ambiente localhost
 */
const isLocalhost = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || 
           hostname.includes('127.0.0.1') ||
           hostname.includes('192.168.') ||
           hostname.includes('10.0.') ||
           hostname.includes('172.');
  }
  return process.env.NODE_ENV === 'development';
};

/**
 * Obter URL da API baseada no ambiente
 */
const getEnvironmentApiUrl = () => {
  return isLocalhost() ? DEV_API_URL : PROD_API_URL;
};

/**
 * Inicializar sistema de ambiente
 */
export const initializeEnv = () => {
  console.log('🚀 Inicializando sistema de ambiente Ortodoxo...');

  if (typeof window !== 'undefined') {
    // Log do estado inicial
    const initialState = {
      configLoaded: window.configLoaded || false,
      configTimestamp: window.CONFIG_TIMESTAMP || null,
      blockingEnabled: typeof window.CONFIG_LOADED !== 'undefined',
      apiUrl: window.ENV?.REACT_APP_API_URL || null,
      hostname: window.location.hostname,
      isLocalEnv: isLocalhost()
    };
    
    console.log('🔍 Estado inicial do sistema:', initialState);

    // Aguardar sistema de bloqueio se habilitado
    if (typeof window.CONFIG_LOADED !== 'undefined' && !window.CONFIG_LOADED) {
      console.log('⏳ Aguardando sistema de bloqueio liberar a aplicação...');
      return window.ENV || {};
    }

    // Criar objeto ENV se não existir
    if (!window.ENV) {
      window.ENV = {};
      console.warn('⚠️ window.ENV não encontrado, criando novo objeto');
    }
    
    // Configurar URL da API se não definida
    if (!window.ENV.REACT_APP_API_URL || window.ENV.REACT_APP_API_URL === '%REACT_APP_API_URL%') {
      console.warn('🔄 URL da API não definida, usando valor baseado no ambiente');
      window.ENV.REACT_APP_API_URL = getEnvironmentApiUrl();
      window.ENV.REACT_APP_ENV = isLocalhost() ? 'development' : 'production';
      console.log('✅ Configuração definida:', {
        apiUrl: window.ENV.REACT_APP_API_URL,
        env: window.ENV.REACT_APP_ENV
      });
    }

    // Log do estado final
    console.log('📊 Estado final do ambiente:', {
      apiUrl: window.ENV.REACT_APP_API_URL || 'não definida',
      environment: window.ENV.REACT_APP_ENV || 'não definido',
      configLoaded: window.configLoaded || false,
      isLocalEnv: isLocalhost(),
      timestamp: new Date().toISOString()
    });
  }

  return window.ENV || {};
};

/**
 * Obter URL da API configurada
 */
export const getApiUrl = () => {
  if (typeof window === 'undefined') {
    return getEnvironmentApiUrl();
  }
  
  // Reinicializar se necessário
  if (!window.ENV || !window.ENV.REACT_APP_API_URL) {
    console.warn('⚠️ ENV ou API_URL não encontrados, reinicializando...');
    initializeEnv();
  }
  
  const apiUrl = window.ENV?.REACT_APP_API_URL;
  
  // Validar URL e aplicar fallback se necessário
  if (!apiUrl || apiUrl === '%REACT_APP_API_URL%') {
    const fallbackUrl = getEnvironmentApiUrl();
    console.warn(`⚠️ URL inválida detectada, usando fallback: ${fallbackUrl}`);
    return fallbackUrl;
  }
  
  return apiUrl;
};

/**
 * Obter configuração do ambiente
 */
export const getEnvironmentConfig = () => {
  return {
    apiUrl: getApiUrl(),
    environment: window.ENV?.REACT_APP_ENV || (isLocalhost() ? 'development' : 'production'),
    isLocalhost: isLocalhost(),
    timestamp: window.CONFIG_TIMESTAMP || new Date().toISOString()
  };
};

/**
 * URL de fallback para emergências
 */
export const getFallbackApiUrl = getEnvironmentApiUrl;

// Auto-inicialização
if (typeof window !== 'undefined') {
  // Aguardar DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeEnv);
  } else {
    // DOM já carregado, inicializar imediatamente
    setTimeout(initializeEnv, 100);
  }
}